package com.upcominds.expedite.model

import com.upcominds.expedite.dto.SavingsChallengeConfigDTO
import com.upcominds.expedite.dto.SocialChallengeConfigDTO
import com.upcominds.expedite.util.toLocalDateText
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.JsonNames
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
@OptIn(ExperimentalSerializationApi::class)
data class Challenge(
    val id: String,
    val name: String,
    val description: String,
    val imageUrl: String,
    val points: Int,
    val durationMinutes: Long,
    val deadline: String,
    val difficulty: Difficulty,
    val type: ChallengeType,
    val contentId: String? = null,
    val savingsConfig: SavingsChallengeConfigDTO? = null,
    val socialConfig: SocialChallengeConfigDTO? = null,
    @SerialName("isCompleted")
    @JsonNames("completed")
    val isCompleted: Boolean = false,
    val participationStatus: String? = null,
    val isCommunityCompetition: Boolean = false,
    val competitionId: String? = null,
) {

    enum class Difficulty {
        EASY,
        MEDIUM,
        HARD,
    }

    fun deadlineFormatted(): String {
        return deadline.toLocalDateText()
    }

    companion object {

        fun dummyChallenge(): Challenge {
            return Challenge(
                id = "1",
                name = "Mindful consumption",
                description = "Reflect on your energy consumption habits and set personal goals",
                imageUrl = "https://example.com/image1.png",
                points = 20,
                durationMinutes = 1000,
                deadline = "2025-10-25T00:00",
                difficulty = Difficulty.EASY,
                type = ChallengeType.QUESTIONNAIRE,
            )
        }

        fun dummyChallenges(): List<Challenge> {
            return listOf(
                dummyChallenge(),
                dummyChallenge().copy(
                    id = "2",
                    name = "Energy audit",
                    description = "Conduct a simple energy audit of your home, identifying areas of improvement.",
                    points = 10,
                    durationMinutes = 1000,
                    deadline = "2024-12-31T00:00",
                ),
            )
        }
    }
}
